/**
 * Pages that have left Priorities.ai for the Claritas app, and where each now lives.
 *
 * Elevation's four layers, M3 to M0, moved there first (Proposal 09 § 8.1,
 * ~/Vault/_system/proposals/09-elevation-separation.md). Wes compared the copies
 * and ruled on 2026-10-18: "redirect the old M0 to M3 addresses". Each old
 * address forwards to its new one, keeping the query and #fragment.
 *
 * These are owner pages (ELEVATION_OWNER_ONLY_PATHS in ./elevationAccess.ts),
 * and the redirect sits behind the same gate, so only Wes is sent there.
 * Everyone else is still sent to the dashboard as before. The page code stays
 * in this repo, unreachable, until the moved pages are removed (§ 7, step 6).
 */

export const CLARITAS_ORIGIN = 'https://claritas-self.vercel.app';

export const MOVED_TO_CLARITAS: Readonly<Record<string, string>> = {
  '/elevation/grammar': '/models/grammar', // M3
  '/elevation/models': '/models/registry', // M2
  '/elevation/lab/m2-model-taxonomy': '/models/m2-model-taxonomy', // M2
  '/elevation/templates': '/models/templates', // M1
  '/elevation/runtime': '/models/runtime', // M0
};

/** The Claritas address for an old one, or null when the page has not moved. */
export function claritasUrlFor(pathname: string, search = '', hash = ''): string | null {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  const there = MOVED_TO_CLARITAS[path.toLowerCase()];
  return there ? `${CLARITAS_ORIGIN}${there}${search}${hash}` : null;
}
